import {BASE_URL} from "../config/app";
import store from "@/store/index";
import router from "@/router/index";
import axios from "axios";
import Vue from "vue";

const config = {
  baseURL: BASE_URL,
  timeout: 0,
  headers: {},
};

// apply interceptor on response
const token = localStorage.getItem("access_token");
const instance = axios.create(config);

if (token) instance.defaults.headers["token"] = token.substring(1).slice(0, -1);
// console.log("aa", instance.defaults.headers);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const code = parseInt(error.response && error.response.status);

    let response = error.response;
    const ignorePages = [
      "/auth/token/refresh",
      "/auth/login",
      "/auth/logout",
      "/auth/otp",
      "/auth/password/forgot",
    ];
    const isIgnorePages = ignorePages.includes(response.config.url);

    if (code === 401 && !isIgnorePages) {
      console.log("retry");

      // if (code === 401) {
      const refresh_token = localStorage.getItem("refresh_token");
      instance
        .post("/auth/token/refresh", {
          refresh_token: refresh_token.substring(1).slice(0, -1),
        })
        .then(({ data }) => {
          this.$store.dispatch("setUser", data.id);
          this.$store.dispatch("setType", data.type);
          this.$store.dispatch("setRefreshToken", data.refresh_token);
          this.$store.dispatch("setAccessToken", data.access_token);
        })
        .catch(() => {
          store.dispatch("logout");
          router.push("/auth/login");
        });
    }else if (code === 404) {
      router.push("/auth");
    } else {
      console.log("error.response.data", error.response.data);

      try {
        if (error.response.data.issues === null) {
          Vue.$toast(error.response.data.msg);
        } else {
          let msg = "";
          try {
            msg += `${error.response.data.msg}\n`;
            for (let i = 0; i < error.response.data.issues.length; i++) {
              msg += `${error.response.data.issues[i].cause} => ${error.response.data.issues[i].msg}`;
              if (i < error.response.data.issues.length - 1) {
                msg += "\n";
              }
            }
          }catch (e) {
            msg = `${error.response.data.title}: ${error.response.data.msg}`;
          }
          Vue.$toast.error(msg);
        }
      } catch (e) {
        console.log("catch", e);
      }
    }
  }
);
const http = instance;

// Bind Axios to Vue.
Vue.$http = instance;
Object.defineProperty(Vue.prototype, "$http", {
  get() {
    return instance;
  },
});

export default http;
